import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../../../shared/enums/request-status';
import {
  changePasswordRequest,
  getAnonymousUserHashRequest,
} from './extra-actions';

type State = {
  status: RequestStatus;
  message: string;
  error: any;
  showError: boolean;
  anonymousUserHashStatus: RequestStatus;
  anonymousUserHashMessage: string;
  anonymousUserHashError: any;
  anonymousUserHash: string | null;
  anonymousUserId: string | null;
};

const initialState: State = {
  status: RequestStatus.Ideal,
  message: '',
  error: '',
  showError: false,
  anonymousUserHashStatus: RequestStatus.Ideal,
  anonymousUserHashMessage: '',
  anonymousUserHashError: null,
  anonymousUserHash: null,
  anonymousUserId: null,
};

const changePasswordSlice = createSlice({
  name: 'changePassword',
  initialState,
  reducers: {
    hideError: (state) => {
      state.showError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(changePasswordRequest.pending, (state) => {
      state.status = RequestStatus.Pending;
      state.showError = false;
    });
    builder.addCase(changePasswordRequest.fulfilled, (state, action) => {
      state.status = RequestStatus.Succeeded;
      state.message = action.payload.message;
    });
    builder.addCase(changePasswordRequest.rejected, (state, action) => {
      state.status = RequestStatus.Failed;
      state.error = action.payload;
      state.showError = !action.payload.isHandled;
    });

    builder.addCase(getAnonymousUserHashRequest.pending, (state) => {
      state.anonymousUserHashStatus = RequestStatus.Pending;
      state.anonymousUserHashError = null;
    });
    builder.addCase(getAnonymousUserHashRequest.fulfilled, (state, action) => {
      state.anonymousUserHashStatus = RequestStatus.Succeeded;
      state.anonymousUserHashMessage = action.payload.message || '';
      state.anonymousUserHash = action.payload.payload?.userHash || null;
      state.anonymousUserId =
        action.payload.payload?.anonymousUserId != null
          ? String(action.payload.payload.anonymousUserId)
          : null;
    });
    builder.addCase(getAnonymousUserHashRequest.rejected, (state, action) => {
      state.anonymousUserHashStatus = RequestStatus.Failed;
      state.anonymousUserHashError = action.payload;
    });
  },
});

export const { hideError } = changePasswordSlice.actions;
export { changePasswordRequest, getAnonymousUserHashRequest };
export default changePasswordSlice.reducer;
